import * as React from "react";
import type { SVGProps } from "react";
const SvgFlipLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6.954 4.8 2.4 9.415m0 0 4.554 4.616M2.4 9.415h15.2a4 4 0 0 1 4 4V15.2a4 4 0 0 1-4 4H12"
    />
  </svg>
);
export default SvgFlipLeft;
